import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import Loading from '../../components/styled/Loading'
import {
  Collapse,
  DatePicker,
  Drawer,
  Input,
  Modal,
  Select,
  Table,
  TreeSelect,
  Button,
  Alert,
} from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import JSZip from 'jszip'
import styled from 'styled-components/macro'
import { createGlobalStyle } from 'styled-components'
import {
  antdTableHorizontalScroll,
  visibleHorizontalScroll,
} from 'src/components/styled/horizontalScroll'
import { useLocation, useHistory, Link } from 'react-router-dom'
import {
  editInvoiceInDatabase,
  getArchivedInvoices,
  getInvoicesWithTempUrl,
  getInvoicesWithTempUrlByRange,
  getInvoiceUrlById,
  getUploadedInvoices,
  getInvoicesTablePage,
  INVOICES_INFO_PAGE_SIZE,
  rematchInvoiceMatching,
  enrichUploadedInvoice,
  linkInvoiceToPurchaseOrder,
  dismissInvoiceDuplicate,
  mergeInvoicePages,
  recordInvoiceDownload,
  updateInvoices,
  bulkArchiveInvoices,
  bulkDeleteInvoices,
  canArchiveInvoice,
} from '../../features/NewInvoicesSlice'
import InvoicesColumns from './InvoicesColumns'
import LoadingButton from '../../components/styled/LoadingButton'
import moment from 'moment/moment'
import AddInvoices from '../../components/AddInvoices'
import MatchInvoiceModal from './MatchInvoiceModal'
import AllocateInvoiceToPosModal from './AllocateInvoiceToPosModal'
import DuplicateResolutionModal from './DuplicateResolutionModal'
import UnreconcileInvoiceModal from './UnreconcileInvoiceModal'
import InvoiceAuditHistoryDrawer from './InvoiceAuditHistoryDrawer'
import Receipting from '../receipting/Receipting'
import CreditNoteCoachModal from './components/CreditNoteCoachModal'
import { CN_DOCUMENT_COPY } from 'src/utils/creditNoteDocumentHelpers'
import { RESPONSIVE_TABLE_SCROLL } from 'src/utils/responsiveTable'
import {
  dismissCreditNoteCoach,
  shouldShowCreditNoteCoach,
} from 'src/utils/creditNoteDocumentStorage'
import {
  clearXeroData,
  fetchXeroOrganizationData,
} from 'src/features/XeroIntegrationSlice'
import { invalidateReceiptingOrdersCache } from 'src/features/ReceiptingSlice'
import { persistManualOrderWholeOrderDiscount } from 'src/utils/persistManualOrderDiscount'
import useIsBlocked from 'src/hooks/useIsBlocked'
import PermissionBlockScreen from 'src/components/shared/PermissionBlockScreen'
import InvoiceMatchToleranceModal from './InvoiceMatchToleranceModal'
import InvoiceForwardSettings from './InvoiceForwardSettings'
import { canConfigureRevenueCategories } from 'src/utils/revenueCategoryAccess'
import {
  emailInvoice,
  readInvoiceForwardSettings,
} from 'src/utils/invoiceForwardApi'
import ThreeWayMatchEducation from 'src/components/shared/ThreeWayMatchEducation'
import {
  applyDocumentTypeFlipToEditState,
  applyEditInvoiceSupplierSelect,
  applyEditInvoiceSupplierTitleInput,
  buildEditInvoiceSavePayload,
  buildEditInvoiceState,
  canEditInvoiceDetails,
  filterInvoiceTableRows,
  getEditInvoiceDetailsBlockReason,
  getInvoiceLifecycleStatusFilterOptions,
  getInvoiceMatchingStatusFilterOptions,
  getInvoiceMatchingStatusToneStyles,
  getInvoiceAppSourceFilterHint,
  getInvoiceSourceFilterOptions,
  getInvoiceDownloadStatusFilterOptions,
  getVenueSuppliersPath,
  hasActiveInvoiceTableFilters,
  INVOICE_MATCHING_STATUS_META,
  INVOICE_MATCHING_SUMMARY_BUCKETS,
  INVOICE_MATCHING_WORK_STATUSES,
  INVOICE_TOTAL_HELPER_TEXT,
  isEditInvoiceNonOmsSupplier,
  isInvoiceClosedLifecycle,
  isInvoiceMatchingWorkPreset,
  mapInvoiceToTableRow,
  invoiceForwardSentLine,
  NON_OMS_SUPPLIER_BADGE_LABEL,
  toggleMatchingStatusFilter,
} from '../../utils/invoiceUploadHelpers'
import { getVenueSuppliers } from 'src/features/VenueSuppliersSlice'
import { buildToleranceBadgeLabel } from '../../utils/invoiceMatchToleranceHelpers'
import { fetchReconciliationToleranceSettings } from '../../utils/invoiceMatchToleranceApi'
import {
  parseInvoicesMatchingFromSearch,
  parseInvoicesInvoiceIdFromSearch,
  parseInvoicesReviewFromSearch,
  parseInvoicesSearchQueryFromSearch,
  parseInvoicesUploadPrefillFromSearch,
  fetchOpenCreditRequestCount,
  buildCreditRequestsPath,
  shouldShowCreditRequestHealthBadge,
  RECEIPTING_HEALTH_BADGE_COLOR,
} from '../../utils/reconciliationHealthApi'
import {
  buildIntegrationsPath,
  buildVenueSuppliersPath,
  countSuppliersWithXeroDefaults,
  getXeroAutoSendBannerState,
  readXeroAutoSendEnabled,
  XERO_AUTO_SEND_MAP_SUPPLIERS_CTA,
} from 'src/utils/xeroAutoSendCopy'
import { resolveXeroOrganizationId } from 'src/utils/xeroOrganization'
import {
  NO_ORDER_QUEUE_TIP,
  getNoOrderGuidanceLinks,
  shouldShowNoOrderQueueTip,
} from '../../utils/invoiceNoOrderGuidance'
import {
  mergeRematchApiResultIntoInvoiceRow,
  shouldAutoRematchBeforeMatchOpen,
} from '../../utils/invoiceMatchRefreshHelpers'
import {
  getInvoicesTableEmptyText,
  getMatchQueueFindWorkGuidance,
  pickNextMatchInvoice,
} from '../../utils/invoiceMatchQueueFindWork'
import { API } from 'src/utils/interceptor'
import useGrowthEngineFeatureGuidance from 'src/hooks/useGrowthEngineFeatureGuidance'
import useGrowthEngineSuggestedData from 'src/hooks/useGrowthEngineSuggestedData'
import GrowthEngineFeatureEmptyState from 'src/components/growthEngine/GrowthEngineFeatureEmptyState'
import { shouldShowInvoiceUploadsGuidedEmpty } from 'src/utils/growthEngineRecommendation'
import {
  bindGuidedEmptySuggestedActions,
  pickAcceptedSuggestedItem,
} from 'src/utils/growthEngineSuggestedData'
import {
  RejectedNotification,
  SuccessNotification,
} from 'src/notifications/SuccessNotification'
import { postPhoneOrders } from 'src/features/AddPhoneOrders'
import AddInvoiceModal from 'src/screens/orders/add-invoice-modal/AddInvoiceModal'
import { proposeManualOrderFromInvoice } from 'src/utils/manualOrderProposalApi'
import {
  BULK_SELECTION_MODE,
  buildBulkArchiveFailureRows,
  buildBulkDeleteFailureRows,
  getBulkArchiveInvoiceIds,
  getBulkArchivableInvoices,
  getBulkDeleteInvoiceIds,
  getBulkDeletableInvoices,
  shouldShowSelectAllFilteredPrompt,
} from '../../utils/invoiceBulkSelectionHelpers'
const { RangePicker } = DatePicker
const { Option } = Select
const { Search } = Input
const { Panel: CollapsePanel } = Collapse

const MATCHING_FILTER_OPTIONS = getInvoiceMatchingStatusFilterOptions()
const LIFECYCLE_STATUS_FILTER_OPTIONS = getInvoiceLifecycleStatusFilterOptions()
const SOURCE_FILTER_OPTIONS = getInvoiceSourceFilterOptions()
const DOWNLOAD_STATUS_FILTER_OPTIONS = getInvoiceDownloadStatusFilterOptions()

const sameStringList = (a = [], b = []) => {
  if (a === b) return true
  if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) {
    return false
  }
  return a.every((value, index) => value === b[index])
}

const STATUS_EXPLANATIONS = [
  {
    color: '#fa8c16',
    label: 'Received',
    description:
      'File is in your library but not on a PO yet — same idea as “No invoice attached” on Goods Receipting.',
  },
  {
    color: '#13c2c2',
    label: 'Invoice attached',
    description:
      'Same wording as Goods Receipting: the file is linked to a PO, but receipting is not closed yet. The PO number shows under the Status badge.',
  },
  {
    color: '#52c41a',
    label: 'Reconciled',
    description:
      'Same idea as Goods Receipting Full accept / reconciled: receipting is saved and this invoice is closed. Match & reconcile does this in one step for a full match.',
  },
  {
    color: '#1890ff',
    label: 'Sent to Xero',
    description: 'Same as Goods Receipting — sent to your accounting platform.',
  },
  {
    color: '#ff4d4f',
    label: 'Error - Cannot Read',
    description:
      'There has been an error processing this invoice, please try again (we will notify you via email when this happens).',
  },
  {
    color: '#ff4d4f',
    label: 'Error Sending to accounting platform',
    description: 'There has been an error sending to your accounting platform.',
  },
]

// Matches antd Tag colors used in the Matching column so the legend
// mirrors what the table actually shows.
const MATCHING_TAG_COLOR_HEX = {
  green: '#52c41a',
  gold: '#faad14',
  volcano: '#fa541c',
  purple: '#722ed1',
  blue: '#1890ff',
  orange: '#fa8c16',
  default: '#8c8c8c',
}

const MATCHING_EXPLANATIONS = Object.values(INVOICE_MATCHING_STATUS_META).map(
  meta => {
    const toneStyles = getInvoiceMatchingStatusToneStyles(meta.tone)
    return {
      color: meta.color
        ? MATCHING_TAG_COLOR_HEX[meta.color] || toneStyles.color
        : toneStyles.color,
      label: meta.label,
      description: meta.guidance,
    }
  },
)

const InvoicesScreen = props => {
  const blocked = useIsBlocked('invoices')

  if (blocked) {
    return <PermissionBlockScreen />
  }

  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const {
    uploadedInvoices,
    archivedInvoices,
    uploadedLoading,
    archivedLoading,
    updatingLoading,
  } = useSelector(state => state.newInvoices)
  const account = useSelector(state => state.auth.account)

  const { venueId } = props

  const [viewMode, setViewMode] = useState('active')
  const [archivedDataSource, setArchivedDataSource] = useState([])

  const [dataSourse, setDataSourse] = useState([])
  const [forwardAddresses, setForwardAddresses] = useState([])
  const [forwardNotes, setForwardNotes] = useState({})
  const [downloading, setDownLoading] = useState(false)
  const [visibleCalendar, setVisibleCalendar] = useState(false)
  const [downloadingInvoice, setDownLoadingInvoice] = useState(null)
  const [downloadingRangeInvoices, setDownloadingRangeInvoices] =
    useState(false)
  const [rangeDate, setRangeDate] = useState([])
  const [suppliers, setSuppliers] = useState([])
  const [editInvoice, setEditInvoice] = useState(null)
  const [updatedInvoice, setUpdatedInvoice] = useState({})
  /** When Edit was opened from Match “Fix details”, reopen Match after save/cancel. */
  const [reopenMatchAfterEdit, setReopenMatchAfterEdit] = useState(false)

  const [selectedSupplier, setSelectedSupplier] = useState(null)
  const [matchModalInvoice, setMatchModalInvoice] = useState(null)
  const [
    creatingMatchingManualOrderInvoiceId,
    setCreatingMatchingManualOrderInvoiceId,
  ] = useState(null)
  const [manualOrderModalOpen, setManualOrderModalOpen] = useState(false)
  const [manualOrderForInvoice, setManualOrderForInvoice] = useState(null)
  const [manualOrderDraft, setManualOrderDraft] = useState({})
  const [manualOrderProposalBundle, setManualOrderProposalBundle] =
    useState(null)
  const [manualOrderDiscountPounds, setManualOrderDiscountPounds] = useState(0)
  const [manualOrderSaving, setManualOrderSaving] = useState(false)
  const [manualOrderInvalid, setManualOrderInvalid] = useState(true)
  /** Ollie / deep-link `?invoiceId=` — open Match once per id. */
  const ollieInvoiceDeepLinkRef = useRef(null)
  const [rematchingInvoiceId, setRematchingInvoiceId] = useState(null)
  const [dismissingDuplicateInvoiceId, setDismissingDuplicateInvoiceId] =
    useState(null)
  const [mergingPagesInvoiceId, setMergingPagesInvoiceId] = useState(null)
  const [allocateModalOpen, setAllocateModalOpen] = useState(false)
  const [allocateInvoice, setAllocateInvoice] = useState(null)
  const [duplicateModalInvoice, setDuplicateModalInvoice] = useState(null)
  const [unreconcileModalInvoice, setUnreconcileModalInvoice] = useState(null)
  const [auditDrawerInvoice, setAuditDrawerInvoice] = useState(null)
  const [goodsReceiptEditInvoice, setGoodsReceiptEditInvoice] = useState(null)
  const [loadingRowId, setLoadingRowId] = React.useState(null)
  const [matchingStatuses, setMatchingStatuses] = useState([])
  const [lifecycleStatuses, setLifecycleStatuses] = useState([])
  const [sources, setSources] = useState([])
  const [uploadDateRange, setUploadDateRange] = useState([])
  const [downloadStatus, setDownloadStatus] = useState('all')
  const [searchQuery, setSearchQuery] = useState('')
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('')
  const [tablePage, setTablePage] = useState(1)
  const [serverTotal, setServerTotal] = useState(0)
  const [tableSummary, setTableSummary] = useState(null)
  /** Page 2+ / quiet refresh: spinner on table only — keep Match queue chrome. */
  const [tableBusy, setTableBusy] = useState(false)
  const [typeFiltersOpen, setTypeFiltersOpen] = useState(false)
  const [uploadPrefill, setUploadPrefill] = useState(null)
  const [requestOpenUpload, setRequestOpenUpload] = useState(0)
  const guidedSuccess = useGrowthEngineFeatureGuidance({
    venueId,
    surface: 'invoices',
    featureId: 'invoice_uploads',
  })
  const suggested = useGrowthEngineSuggestedData({
    venueId,
    featureId: 'invoice_uploads',
    items: guidedSuccess?.suggestedData?.items,
  })
  const [toleranceSettings, setToleranceSettings] = useState(null)
  const [toleranceLoading, setToleranceLoading] = useState(false)
  const [toleranceModalOpen, setToleranceModalOpen] = useState(false)
  const [creditNoteCoachOpen, setCreditNoteCoachOpen] = useState(false)
  const [openCreditRequestCount, setOpenCreditRequestCount] = useState(0)
  const [bulkSelectedRowKeys, setBulkSelectedRowKeys] = useState([])
  const [bulkSelectAllFiltered, setBulkSelectAllFiltered] = useState(false)
  const [bulkActionLoading, setBulkActionLoading] = useState(false)
  const [bulkFailureModal, setBulkFailureModal] = useState(null)
  const venue = useSelector(state => state.venue?.venue || {})
  const { xeroConnection, xeroConnectionExpired } = venue
  const automaticSendToXero = readXeroAutoSendEnabled(venue)
  const xeroMetadataError = useSelector(state => state.xeroIntegration?.error)
  const xeroMetadataLoading = useSelector(
    state => state.xeroIntegration?.isLoading,
  )
  const xeroConnected = Boolean(xeroConnection?.accessToken)
  const showXeroMetadataWarning =
    xeroConnected && Boolean(xeroMetadataError) && !xeroMetadataLoading
  const venueSuppliers = useSelector(state =>
    (state.venueSuppliers.venueSuppliers || []).filter(
      venueSupplier => venueSupplier.isActive,
    ),
  )
  const allVenueSuppliersForManualOrder = useSelector(
    state => state.venueSuppliers.venueSuppliers || [],
  )

  useEffect(() => {
    const handle = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery)
    }, 300)
    return () => clearTimeout(handle)
  }, [searchQuery])

  const ensureInvoiceLibrary = useCallback(
    (options = {}) => {
      if (!venueId) return Promise.resolve(false)
      return dispatch(getUploadedInvoices(venueId, options))
    },
    [dispatch, venueId],
  )

  const loadActiveInvoicesPage = useCallback(
    async ({
      page = tablePage,
      silent = false,
      // Summary is venue-wide (chips). Only fetch on page 1 by default;
      // page 2+ reuses tableSummary. Pass true after match/upload/edit.
      includeSummary,
    } = {}) => {
      if (!venueId) return null
      const wantSummary =
        includeSummary != null ? Boolean(includeSummary) : page === 1
      // First page may blank the tab; later pages only spin the table.
      const tableOnlyLoading = page > 1
      const effectiveSilent = silent || tableOnlyLoading

      if (tableOnlyLoading) {
        setTableBusy(true)
      }

      try {
        const result = await dispatch(
          getInvoicesTablePage(venueId, {
            page,
            limit: INVOICES_INFO_PAGE_SIZE,
            matchingStatuses,
            lifecycleStatuses,
            sources,
            uploadDateFrom: uploadDateRange?.[0] || null,
            uploadDateTo: uploadDateRange?.[1] || null,
            downloadStatus,
            search: debouncedSearchQuery,
            includeSummary: wantSummary,
            silent: effectiveSilent,
          }),
        )

        if (!result || result.error) {
          return result
        }

        const mapped = (result.items || []).map(invoice =>
          mapInvoiceToTableRow(invoice),
        )
        setDataSourse(mapped)
        setServerTotal(result.total || 0)
        // Keep previous chips when this request skipped summary.
        if (result.summary) {
          setTableSummary(result.summary)
        }

        const uniqueSuppliers = (result.items || []).reduce(
          (unique, invoice) => {
            const exists = unique.some(
              item => item.value === invoice.supplierTitle,
            )
            if (!exists && invoice.supplierTitle) {
              unique.push({
                title: invoice.supplierTitle,
                value: invoice.supplierTitle,
              })
            }
            return unique
          },
          [],
        )
        if (mapped.length) {
          uniqueSuppliers.push({
            title: 'Other',
            value: 'null',
          })
        }
        setSuppliers(uniqueSuppliers)

        return result
      } finally {
        if (tableOnlyLoading) {
          setTableBusy(false)
        }
      }
    },
    [
      venueId,
      dispatch,
      tablePage,
      matchingStatuses,
      lifecycleStatuses,
      sources,
      uploadDateRange,
      downloadStatus,
      debouncedSearchQuery,
    ],
  )

  useEffect(() => {
    if (!venueId || viewMode === 'archive') return
    void loadActiveInvoicesPage({ page: tablePage })
  }, [
    venueId,
    viewMode,
    tablePage,
    matchingStatuses,
    lifecycleStatuses,
    sources,
    uploadDateRange,
    downloadStatus,
    debouncedSearchQuery,
  ])

  // Filter / search changes should restart at page 1.
  useEffect(() => {
    setTablePage(prev => (prev === 1 ? prev : 1))
  }, [
    matchingStatuses,
    lifecycleStatuses,
    sources,
    uploadDateRange,
    downloadStatus,
    debouncedSearchQuery,
    venueId,
  ])

  useEffect(() => {
    if (!venueId) {
      setOpenCreditRequestCount(0)
      return undefined
    }
    let cancelled = false
    fetchOpenCreditRequestCount({ venueId, apiGet: API.get })
      .then(count => {
        if (!cancelled) setOpenCreditRequestCount(count)
        return null
      })
      .catch(() => {
        if (!cancelled) setOpenCreditRequestCount(0)
        return null
      })
    return () => {
      cancelled = true
    }
  }, [venueId])

  useEffect(() => {
    setBulkSelectedRowKeys([])
    setBulkSelectAllFiltered(false)
    setBulkFailureModal(null)
  }, [
    viewMode,
    matchingStatuses,
    lifecycleStatuses,
    sources,
    uploadDateRange,
    downloadStatus,
    searchQuery,
  ])

  const xeroBanner = useMemo(
    () =>
      getXeroAutoSendBannerState({
        xeroConnected,
        xeroExpired: xeroConnectionExpired,
        autoSendEnabled: automaticSendToXero,
        mappedSupplierCount: countSuppliersWithXeroDefaults(venueSuppliers),
        activeSupplierCount: venueSuppliers.length,
      }),
    [xeroConnected, xeroConnectionExpired, automaticSendToXero, venueSuppliers],
  )

  useEffect(() => {
    // Suppliers back the banner's mapping check, not just the Edit modal.
    if (venueId && (editInvoice || xeroConnected)) {
      dispatch(getVenueSuppliers(venueId))
    }
  }, [venueId, editInvoice, xeroConnected, dispatch])

  useEffect(() => {
    const matchingFromUrl = parseInvoicesMatchingFromSearch(location.search)
    const searchFromUrl = parseInvoicesSearchQueryFromSearch(location.search)
    const uploadFromUrl = parseInvoicesUploadPrefillFromSearch(location.search)
    const reviewFromUrl = parseInvoicesReviewFromSearch(location.search)

    // Ollie / health: `?review=1` applies Needs my review (outstanding work).
    if (reviewFromUrl) {
      setMatchingStatuses([...INVOICE_MATCHING_WORK_STATUSES])
      setTypeFiltersOpen(true)
      if (searchFromUrl) {
        setSearchQuery(prev => (prev === searchFromUrl ? prev : searchFromUrl))
      }
      const params = new URLSearchParams(
        location.search.startsWith('?')
          ? location.search.slice(1)
          : location.search,
      )
      params.delete('review')
      const nextSearch = params.toString()
      history.replace({
        pathname: location.pathname,
        search: nextSearch ? `?${nextSearch}` : '',
        hash: location.hash || '',
      })
      return
    }

    // Legacy tab deep-link applied the full “Needs my review” set. That is a
    // preset users opt into — not a default. Strip it so the queue opens clean.
    if (isInvoiceMatchingWorkPreset(matchingFromUrl)) {
      setMatchingStatuses(prev => (prev.length ? [] : prev))
      const params = new URLSearchParams(
        location.search.startsWith('?')
          ? location.search.slice(1)
          : location.search,
      )
      params.delete('matching')
      const nextSearch = params.toString()
      history.replace({
        pathname: location.pathname,
        search: nextSearch ? `?${nextSearch}` : '',
        hash: location.hash || '',
      })
      if (searchFromUrl) {
        setSearchQuery(prev => (prev === searchFromUrl ? prev : searchFromUrl))
      }
      return
    }

    setMatchingStatuses(prev =>
      sameStringList(prev, matchingFromUrl) ? prev : matchingFromUrl,
    )
    if (matchingFromUrl.length) {
      setTypeFiltersOpen(true)
    }
    if (searchFromUrl) {
      setSearchQuery(prev => (prev === searchFromUrl ? prev : searchFromUrl))
    }

    // GR Match empty → upload deep link: keep prefill, strip one-shot params.
    if (uploadFromUrl.upload) {
      setUploadPrefill(uploadFromUrl)
      const params = new URLSearchParams(
        location.search.startsWith('?')
          ? location.search.slice(1)
          : location.search,
      )
      params.delete('upload')
      params.delete('po')
      params.delete('supplierId')
      params.delete('supplier')
      const nextSearch = params.toString()
      history.replace({
        pathname: location.pathname,
        search: nextSearch ? `?${nextSearch}` : '',
        hash: location.hash || '',
      })
    }
  }, [location.search, location.pathname, location.hash, history])

  useEffect(() => {
    let cancelled = false
    const loadTolerance = async () => {
      if (!venueId) return
      setToleranceLoading(true)
      try {
        const data = await fetchReconciliationToleranceSettings(venueId)
        if (!cancelled) {
          setToleranceSettings(data)
        }
      } catch (error) {
        console.error('Failed to load match tolerance settings', error)
        if (!cancelled) {
          setToleranceSettings(null)
        }
      } finally {
        if (!cancelled) {
          setToleranceLoading(false)
        }
      }
    }
    loadTolerance()
    return () => {
      cancelled = true
    }
  }, [venueId])

  useEffect(() => {
    if (viewMode === 'archive') {
      dispatch(getArchivedInvoices(venueId))
    }
  }, [viewMode, venueId, dispatch])

  // Active table rows come from getInvoicesTablePage — do not overwrite with
  // the full library (Receipting / Match still use uploadedInvoices).
  useEffect(() => {
    if (editInvoice) {
      setUpdatedInvoice(buildEditInvoiceState(editInvoice))
    }
  }, [editInvoice])

  useEffect(() => {
    filterInvoicesInfo(archivedInvoices, true)
  }, [archivedInvoices])

  // After uploads / GR helpers refresh the library, refresh the visible page.
  useEffect(() => {
    if (!venueId || viewMode === 'archive') return
    if (!uploadedInvoices?.length) return
    void loadActiveInvoicesPage({
      page: tablePage,
      silent: true,
      includeSummary: true,
    })
  }, [uploadedInvoices])

  const filterInvoicesInfo = (invoices, isArchivedList = false) => {
    const filtered = invoices.map(invoice =>
      mapInvoiceToTableRow(invoice, isArchivedList),
    )

    if (isArchivedList) {
      setArchivedDataSource(filtered)
      return
    }

    setDataSourse(filtered)
    const uniqueSuppliers = invoices.reduce((unique, invoice) => {
      const exists = unique.some(item => item.value === invoice.supplierTitle)
      if (!exists && invoice.supplierTitle) {
        unique.push({
          title: invoice.supplierTitle,
          value: invoice.supplierTitle,
        })
      }

      return unique
    }, [])

    filtered.length &&
      uniqueSuppliers.push({
        title: 'Other',
        value: 'null',
      })

    setSuppliers(uniqueSuppliers)
  }

  // const updateInvoiceDB = (invoiceId, field, value) => {
  //   dispatch(updateInvoice(invoiceId, field, value))
  // }

  const downloadInvoicesToFolder = async (invoicesUrls, zipName) => {
    try {
      if (!Array.isArray(invoicesUrls) || invoicesUrls.length === 0) return

      const zip = new JSZip()
      const photos = invoicesUrls.map(async (invoiceFile, index) => {
        const invoiceUrl =
          typeof invoiceFile === 'string'
            ? invoiceFile
            : invoiceFile.imageUrl ||
              invoiceFile?.invoiceUrl ||
              invoiceFile?.invoiceTempUrl ||
              invoiceFile?.url ||
              invoiceFile?.files?.[0]?.url

        if (!invoiceUrl) return

        const response = await fetch(invoiceUrl)
        if (!response.ok) {
          throw new Error(
            `Failed to download invoice. Status: ${response.status}`,
          )
        }
        const blob = await response.blob()

        const mimeType = response.headers.get('content-type') || 'image/jpeg'

        zip.file(`invoice${index + 1}.${mimeType.split('/')[1]}`, blob, {
          binary: true,
        })
      })

      await Promise.all(photos)
      const zipBlob = await zip.generateAsync({ type: 'blob' })

      const downloadLink = document.createElement('a')
      downloadLink.href = URL.createObjectURL(zipBlob)
      downloadLink.download = zipName
      document.body.appendChild(downloadLink)
      downloadLink.click()
      document.body.removeChild(downloadLink)
    } catch (e) {
      console.error('Error in downloadInvoicesToFolder', e)
    }
  }

  const downloadAllInvoicesToFolder = async () => {
    setDownLoading(true)
    try {
      const invoicesUrls = await getInvoicesWithTempUrl(
        venueId,
        selectedSupplier,
      )

      await downloadInvoicesToFolder(invoicesUrls, 'OMS_invoices.zip')
      setDownLoading(false)
    } catch (e) {
      setDownLoading(false)
      console.log('Error in downloadAllInvoicesToFolder', e)
    }
  }

  const downloadRangeInvoicesToFolder = async () => {
    setDownloadingRangeInvoices(true)
    try {
      const invoicesUrls = await getInvoicesWithTempUrlByRange(
        venueId,
        rangeDate,
      )

      await downloadInvoicesToFolder(
        invoicesUrls,
        `${rangeDate[0]}-${rangeDate[1]}.zip`,
      )
      setDownloadingRangeInvoices(false)
    } catch (e) {
      setDownloadingRangeInvoices(false)
      console.log('Error in downloadRangeInvoicesToFolder', e)
    }
  }
  const handleDownloadInvoice = async invoice => {
    try {
      setDownLoadingInvoice(invoice.id)
      let invoiceUrl
      let filename

      if (invoice.supplierUpload && invoice.invoiceUrl) {
        invoiceUrl = invoice.invoiceUrl
        filename = invoice.fileName || invoice.key || 'invoice'
      } else {
        const invoiceData = await getInvoiceUrlById(venueId, invoice.id)
        invoiceUrl = invoiceData.invoiceUrl
        filename = invoice.fileName || 'invoice'
      }

      const response = await fetch(invoiceUrl)

      if (!response.ok) {
        throw new Error(
          `Failed to download invoice. Status: ${response.status}`,
        )
      }
      const contentType = response.headers.get('Content-Type')
      const isPdf = contentType && contentType.includes('application/pdf')
      const contentDisposition = response.headers.get('Content-Disposition')
      const filenameMatch =
        contentDisposition && contentDisposition.match(/filename="(.+?)"/)
      const finalFilename = filenameMatch
        ? filenameMatch[1]
        : filename.includes('.')
        ? filename
        : isPdf
        ? `${filename}.pdf`
        : `${filename}.jpg`

      const blob = await response.blob()

      const downloadLink = document.createElement('a')
      downloadLink.href = URL.createObjectURL(blob)
      downloadLink.download = finalFilename

      document.body.appendChild(downloadLink)
      downloadLink.click()
      document.body.removeChild(downloadLink)
      setDownLoadingInvoice(null)

      // Track download after a successful file save — never block the download UX.
      try {
        const result = await recordInvoiceDownload(invoice.id, {
          venueId,
          downloadedBy: account?._id || account?.id,
          downloadedByName:
            account?.name ||
            account?.emailAddress ||
            account?.username ||
            'Admin',
        })
        if (result?.invoice) {
          dispatch(updateInvoices({ invoice: result.invoice }))
        }
      } catch (recordError) {
        console.error('Error recording invoice download:', recordError.message)
      }
    } catch (error) {
      console.error('Error downloading invoice:', error.message)
      setDownLoadingInvoice(null)
    }
  }
  const disableEndDate = current => current.valueOf() > moment.now()

  const onChangeDate = (value, dateString) => {
    setVisibleCalendar(false)
    if (dateString) {
      setRangeDate(dateString)
    } else {
      setRangeDate([])
    }
  }

  useEffect(() => {
    if (xeroConnection && xeroConnection?.organizations?.length) {
      const organizationId = resolveXeroOrganizationId(xeroConnection)
      if (!organizationId) return
      dispatch(fetchXeroOrganizationData(organizationId, venueId))
    }
  }, [xeroConnection, venueId])

  // Cleanup Redux state when component unmounts
  useEffect(() => {
    return () => {
      dispatch(clearXeroData())
    }
  }, [dispatch])

  const archivedByUsername =
    account?.name || account?.emailAddress || account?.username || 'Admin'

  const isArchiveView = viewMode === 'archive'

  useEffect(() => {
    const products = manualOrderDraft?.products
    if (!Array.isArray(products) || !products.length) {
      setManualOrderInvalid(true)
      return
    }
    const invalid = products.some(row => {
      const hasSelectedProduct = Boolean(row?.product)
      const hasManualTitle = Boolean(String(row?.title || '').trim())
      const quantity = Number(row?.quantity)
      const unitPrice = Number(
        row?.OMSPrice !== undefined && row?.OMSPrice !== null
          ? row.OMSPrice
          : row?.price,
      )
      return (
        (!hasSelectedProduct && !hasManualTitle) ||
        !Number.isFinite(quantity) ||
        quantity <= 0 ||
        !Number.isFinite(unitPrice) ||
        unitPrice < 0
      )
    })
    setManualOrderInvalid(invalid || !manualOrderDraft?.supplier)
  }, [manualOrderDraft])

  const closeManualOrderModal = () => {
    setManualOrderModalOpen(false)
    setManualOrderForInvoice(null)
    setManualOrderDraft({})
    setManualOrderProposalBundle(null)
    setManualOrderDiscountPounds(0)
    setManualOrderSaving(false)
  }

  const handleCreateMatchingManualOrder = async invoice => {
    if (!invoice?.id || creatingMatchingManualOrderInvoiceId) return

    Modal.confirm({
      title: 'Create order from invoice?',
      className: 'manual-order-supplier-confirm',
      okText: 'Continue',
      cancelText: 'Cancel',
      okButtonProps: {
        style: { background: '#7cb305', borderColor: '#7cb305' },
      },
      width: 520,
      content: (
        <div>
          <p style={{ marginBottom: 8 }}>
            OMS will propose a <strong>historical manual order</strong> from
            this invoice’s extracted data (supplier, lines, quantities, prices,
            VAT, dates).
          </p>
          <p style={{ marginBottom: 8 }}>
            Review and correct anything needed, then confirm. OMS will create
            the order, assign a PO, and <strong>link this invoice</strong>{' '}
            automatically — then open Match so you can reconcile.
          </p>
          <p style={{ marginBottom: 0, color: 'rgba(0,0,0,0.45)' }}>
            Nothing is sent to your supplier. You can still create a manual
            order the old way on Orders if you prefer.
          </p>
        </div>
      ),
      onOk: async () => {
        setCreatingMatchingManualOrderInvoiceId(invoice.id)
        try {
          if (!allVenueSuppliersForManualOrder?.length) {
            await dispatch(getVenueSuppliers(venueId))
          }
          const result = await proposeManualOrderFromInvoice({
            invoiceId: invoice.id,
          })
          if (!result?.proposal) {
            throw new Error('No proposed order returned')
          }
          setManualOrderForInvoice(invoice)
          setManualOrderProposalBundle({
            proposal: result.proposal,
            warnings: result.warnings || [],
            appliedAt: Date.now(),
          })
          setManualOrderDraft({
            PONumber:
              result.proposal.poNumber || invoice.purchaseOrderNumber || '',
          })
          setManualOrderModalOpen(true)
        } catch (error) {
          RejectedNotification({
            message: 'Could not propose order from invoice',
            description:
              error?.message ||
              'Try Manually add order on Orders, or fix details and Match again.',
          })
        } finally {
          setCreatingMatchingManualOrderInvoiceId(null)
        }
      },
    })
  }

  const handleSaveMatchingManualOrder = async () => {
    if (!manualOrderForInvoice?.id || manualOrderInvalid) return
    setManualOrderSaving(true)
    const sourceInvoice = manualOrderForInvoice
    try {
      // Ensure we know the PO before create so we can auto-link without
      // asking the user to copy it back onto the invoice.
      const poToUse =
        String(manualOrderDraft?.PONumber || '').trim() || `PO${Date.now()}`

      const createResult = await postPhoneOrders({
        ...manualOrderDraft,
        PONumber: poToUse,
        venue: venueId,
      })
      const createdPo = String(
        createResult?.purchaseOrderNumber ||
          createResult?.data?.purchaseOrderNumber ||
          poToUse,
      ).trim()

      // Persist whole-order discount so GR / reconcile match create-screen total.
      await persistManualOrderWholeOrderDiscount({
        dispatch,
        venueId,
        purchaseOrderNumber: createdPo,
        discountPounds: manualOrderDiscountPounds,
      })

      // Stamp PO on the invoice when missing/different, then soft-link.
      try {
        const invoicePo = String(sourceInvoice.purchaseOrderNumber || '').trim()
        if (!invoicePo || invoicePo !== createdPo) {
          await enrichUploadedInvoice(sourceInvoice.id, {
            purchaseOrderNumber: createdPo,
          })
        }
      } catch (enrichError) {
        console.warn(
          'Could not stamp invoice PO after create-from-invoice',
          enrichError,
        )
      }

      try {
        await linkInvoiceToPurchaseOrder(sourceInvoice.id, {
          purchaseOrderNumber: createdPo,
        })
      } catch (linkError) {
        // Fall through to rematch — user can still Match manually.
        console.warn(
          'Could not auto-link invoice after create-from-invoice',
          linkError,
        )
      }

      let rematchResult = null
      try {
        rematchResult = await rematchInvoiceMatching(sourceInvoice.id)
      } catch (rematchError) {
        console.warn(
          'Could not rematch invoice after create-from-invoice',
          rematchError,
        )
      }

      dispatch(invalidateReceiptingOrdersCache())
      await ensureInvoiceLibrary({ silent: true })
      await loadActiveInvoicesPage({
        page: tablePage,
        silent: true,
        includeSummary: true,
      })

      const refreshedRow =
        mergeRematchApiResultIntoInvoiceRow(
          sourceInvoice,
          rematchResult || {},
        ) || sourceInvoice
      const invoiceForMatch = {
        ...refreshedRow,
        purchaseOrderNumber: refreshedRow.purchaseOrderNumber || createdPo,
        id: sourceInvoice.id,
      }

      closeManualOrderModal()

      SuccessNotification({
        message: 'Order created and invoice linked',
        description: createdPo
          ? `PO ${createdPo} is in Goods receipting and linked to this invoice. Nothing was sent to the supplier — finish Match / reconcile below.`
          : 'Manual order saved and linked. Nothing was sent to the supplier — finish Match / reconcile below.',
      })

      // Drop user straight into reconciliation — no PO copy-paste round trip.
      setMatchModalInvoice(invoiceForMatch)
    } catch (error) {
      RejectedNotification({
        message: 'Could not create order from invoice',
        description:
          error?.response?.data?.message ||
          error?.message ||
          'Please review the proposed order and try again.',
      })
    } finally {
      setManualOrderSaving(false)
    }
  }

  const handleMatchInvoice = async invoice => {
    // Guard: a Possible Duplicate must be reviewed (archived / dismissed)
    // before matching, so users don't fall into the link-only trap.
    if (invoice?.matchingStatus === 'possible_duplicate') {
      void ensureInvoiceLibrary({ silent: true })
      setDuplicateModalInvoice(invoice)
      return
    }
    if (!invoice?.id) return
    if (rematchingInvoiceId || dismissingDuplicateInvoiceId) return

    if (shouldAutoRematchBeforeMatchOpen(invoice)) {
      setRematchingInvoiceId(invoice.id)
      try {
        const result = await rematchInvoiceMatching(invoice.id)
        const merged = mergeRematchApiResultIntoInvoiceRow(invoice, result)
        setMatchModalInvoice(merged)
        // Refresh the table quietly — a full uploadedLoading cycle would
        // blank the screen (and unmount this modal) before it opens.
        void ensureInvoiceLibrary({ silent: true })
        void loadActiveInvoicesPage({
          page: tablePage,
          silent: true,
          includeSummary: true,
        })
      } catch (error) {
        RejectedNotification({
          message: 'Could not refresh matching',
          description:
            error?.response?.data?.message ||
            error?.message ||
            'Opening Match with the last saved result.',
        })
        setMatchModalInvoice(invoice)
      } finally {
        setRematchingInvoiceId(null)
      }
      return
    }

    void ensureInvoiceLibrary({ silent: true })
    setMatchModalInvoice(invoice)
  }

  const closeMatchModal = () => {
    setMatchModalInvoice(null)
  }

  const stripInvoiceIdFromUrl = useCallback(() => {
    const params = new URLSearchParams(
      location.search.startsWith('?')
        ? location.search.slice(1)
        : location.search,
    )
    if (!params.has('invoiceId')) return
    params.delete('invoiceId')
    const nextSearch = params.toString()
    history.replace({
      pathname: location.pathname,
      search: nextSearch ? `?${nextSearch}` : '',
      hash: location.hash || '',
    })
  }, [history, location.hash, location.pathname, location.search])

  const handleFixDetailsFromMatch = invoice => {
    if (!invoice) return
    setMatchModalInvoice(null)
    setReopenMatchAfterEdit(true)
    setEditInvoice(invoice)
  }

  const closeEditInvoiceModal = ({ reopenMatch = false } = {}) => {
    const invoiceForMatch = editInvoice
    const shouldReopen = reopenMatch && reopenMatchAfterEdit && invoiceForMatch
    setEditInvoice(null)
    setReopenMatchAfterEdit(false)
    if (shouldReopen) {
      setMatchModalInvoice(invoiceForMatch)
    }
  }

  const handleInvoiceMatched = async () => {
    setMatchModalInvoice(null)
    // Reload invoices so Status + method reflect link vs reconcile, and
    // invalidate GR cache so the next Goods Receipting visit is fresh.
    dispatch(invalidateReceiptingOrdersCache())
    await ensureInvoiceLibrary({ silent: true })
    await loadActiveInvoicesPage({
      page: tablePage,
      silent: true,
      includeSummary: true,
    })
  }

  const handleUnreconcileInvoice = invoice => {
    setUnreconcileModalInvoice(invoice)
  }

  const handleUnreconcileCompleted = async () => {
    setUnreconcileModalInvoice(null)
    dispatch(invalidateReceiptingOrdersCache())
    await dispatch(getUploadedInvoices(venueId))
  }

  const handleAllocateInvoice = invoice => {
    setAllocateInvoice(invoice)
    setAllocateModalOpen(true)
  }

  const handleRematchInvoice = async invoice => {
    const invoiceId = invoice?.id
    if (!invoiceId || rematchingInvoiceId || dismissingDuplicateInvoiceId)
      return

    setRematchingInvoiceId(invoiceId)
    try {
      const result = await rematchInvoiceMatching(invoiceId)
      SuccessNotification({
        message: result?.skipped
          ? 'Matching not re-run'
          : 'Matching checked again',
        description: result?.skipped
          ? result?.message
          : `Status is now ${result?.matchingStatus || 'updated'}.`,
      })
      await ensureInvoiceLibrary({ silent: true })
      await loadActiveInvoicesPage({
        page: tablePage,
        silent: true,
        includeSummary: true,
      })
    } catch (error) {
      RejectedNotification({
        message: 'Could not check matching again',
        description:
          error?.response?.data?.message ||
          error?.message ||
          'Please try again.',
      })
    } finally {
      setRematchingInvoiceId(null)
    }
  }

  const handleDismissDuplicate = async invoice => {
    const invoiceId = invoice?.id
    if (
      !invoiceId ||
      dismissingDuplicateInvoiceId ||
      rematchingInvoiceId ||
      mergingPagesInvoiceId
    )
      return

    const wasAddPagesOffer = Boolean(
      invoice?.matchSummary?.addPagesOffered &&
        invoice?.matchSummary?.addPagesTargetInvoiceId,
    )

    setDismissingDuplicateInvoiceId(invoiceId)
    try {
      const result = await dismissInvoiceDuplicate(invoiceId)
      SuccessNotification({
        message: wasAddPagesOffer
          ? 'Marked as a different invoice'
          : 'Marked as not a duplicate',
        description: result?.skipped
          ? result?.message
          : `Matching status is now ${result?.matchingStatus || 'updated'}.`,
      })
      setDuplicateModalInvoice(null)
      await ensureInvoiceLibrary({ silent: true })
      await loadActiveInvoicesPage({
        page: tablePage,
        silent: true,
        includeSummary: true,
      })
    } catch (error) {
      RejectedNotification({
        message: wasAddPagesOffer
          ? 'Could not dismiss add-pages offer'
          : 'Could not mark as not a duplicate',
        description:
          error?.response?.data?.message ||
          error?.message ||
          'Please try again.',
      })
    } finally {
      setDismissingDuplicateInvoiceId(null)
    }
  }

  const handleMergePages = async invoice => {
    const invoiceId = invoice?.id
    if (
      !invoiceId ||
      mergingPagesInvoiceId ||
      dismissingDuplicateInvoiceId ||
      rematchingInvoiceId
    )
      return

    const targetInvoiceId =
      invoice?.matchSummary?.addPagesTargetInvoiceId || null

    setMergingPagesInvoiceId(invoiceId)
    try {
      const result = await mergeInvoicePages(invoiceId, { targetInvoiceId })
      SuccessNotification({
        message: 'Pages added to existing invoice',
        description: result?.pageCount
          ? `Invoice now has ${result.pageCount} page(s). Match and reconcile once.`
          : result?.message || 'Merged successfully.',
      })
      setDuplicateModalInvoice(null)
      await ensureInvoiceLibrary({ silent: true })
      await loadActiveInvoicesPage({
        page: tablePage,
        silent: true,
        includeSummary: true,
      })
    } catch (error) {
      RejectedNotification({
        message: 'Could not add pages',
        description:
          error?.response?.data?.message ||
          error?.message ||
          'Please try again.',
      })
    } finally {
      setMergingPagesInvoiceId(null)
    }
  }

  const closeAllocateModal = () => {
    setAllocateModalOpen(false)
    setAllocateInvoice(null)
  }

  const handleInvoiceAllocated = async () => {
    closeAllocateModal()
    dispatch(invalidateReceiptingOrdersCache())
    await ensureInvoiceLibrary({ silent: true })
    await loadActiveInvoicesPage({
      page: tablePage,
      silent: true,
      includeSummary: true,
    })
  }

  useEffect(() => {
    if (!venueId) return undefined
    let cancelled = false
    readInvoiceForwardSettings(venueId)
      .then(data => {
        if (!cancelled)
          setForwardAddresses(Array.isArray(data?.emails) ? data.emails : [])
        return null
      })
      .catch(() => {
        if (!cancelled) setForwardAddresses([])
      })
    return () => {
      cancelled = true
    }
  }, [venueId])

  const emailInvoiceRow = async invoice => {
    try {
      const result = await emailInvoice(invoice.id)
      const to = Array.isArray(result?.to) ? result.to : forwardAddresses
      const sent = Boolean(result?.sent)
      setForwardNotes(current => ({
        ...current,
        [invoice.id]: {
          note: sent
            ? `Emailed to ${to.join(', ')}`
            : 'This invoice could not be emailed.',
          history: sent
            ? [
                ...(invoice.forwardHistory || []),
                invoiceForwardSentLine(new Date().toISOString(), to),
              ]
            : invoice.forwardHistory || [],
        },
      }))
    } catch {
      setForwardNotes(current => ({
        ...current,
        [invoice.id]: {
          note: 'This invoice could not be emailed.',
          history: invoice.forwardHistory || [],
        },
      }))
    }
  }

  const sourceTableData = (isArchiveView ? archivedDataSource : dataSourse).map(
    row =>
      forwardNotes[row.id]
        ? {
            ...row,
            forwardNote: forwardNotes[row.id].note,
            forwardHistory: forwardNotes[row.id].history,
          }
        : row,
  )
  const hasInvoices = isArchiveView
    ? sourceTableData.length > 0
    : serverTotal > 0 || sourceTableData.length > 0

  useEffect(() => {
    if (!venueId || viewMode === 'archive') {
      setCreditNoteCoachOpen(false)
      return
    }
    setCreditNoteCoachOpen(shouldShowCreditNoteCoach(venueId, { hasInvoices }))
  }, [venueId, viewMode, hasInvoices])

  const uploadDateFrom = uploadDateRange?.[0] || null
  const uploadDateTo = uploadDateRange?.[1] || null

  // Active view is filtered on the server; archive view stays client-side.
  const tableData = useMemo(() => {
    if (isArchiveView) {
      return filterInvoiceTableRows(sourceTableData, {
        matchingStatuses,
        lifecycleStatuses,
        sources,
        uploadDateFrom,
        uploadDateTo,
        downloadStatus,
        searchQuery,
      })
    }
    return sourceTableData
  }, [
    isArchiveView,
    sourceTableData,
    matchingStatuses,
    lifecycleStatuses,
    sources,
    uploadDateFrom,
    uploadDateTo,
    downloadStatus,
    searchQuery,
  ])

  // Ollie “View outstanding invoices / Review discrepancy” → open this record.
  useEffect(() => {
    if (blocked || isArchiveView) return undefined
    const invoiceId = parseInvoicesInvoiceIdFromSearch(location.search)
    if (!invoiceId) {
      ollieInvoiceDeepLinkRef.current = null
      return undefined
    }
    if (ollieInvoiceDeepLinkRef.current === invoiceId) return undefined
    if (uploadedLoading || tableBusy) return undefined

    const idOf = row => String(row?.id || row?._id || '').trim()
    const fromTable = (tableData || []).find(row => idOf(row) === invoiceId)
    const fromLibrary = (uploadedInvoices || [])
      .map(invoice => mapInvoiceToTableRow(invoice))
      .find(row => idOf(row) === invoiceId)
    const row = fromTable || fromLibrary

    ollieInvoiceDeepLinkRef.current = invoiceId
    stripInvoiceIdFromUrl()

    if (!row) {
      RejectedNotification({
        message: 'Invoice not available',
        description:
          'That invoice may have been deleted, moved, or finished already. Showing the invoices list instead.',
      })
      return undefined
    }

    if (isInvoiceClosedLifecycle(row) || row.isArchived) {
      SuccessNotification({
        message: 'Already completed',
        description:
          'This invoice no longer needs matching. Showing the invoices list instead.',
      })
      return undefined
    }

    void handleMatchInvoice(row)
    return undefined
  }, [
    blocked,
    isArchiveView,
    location.search,
    uploadedLoading,
    tableBusy,
    tableData,
    uploadedInvoices,
    stripInvoiceIdFromUrl,
  ])

  // Page 1 / archive: full-tab Loading. Page 2+: tableBusy spins the table only.
  const showFullScreenLoading = isArchiveView
    ? archivedLoading
    : uploadedLoading && !tableBusy
  const hasActiveFilters = hasActiveInvoiceTableFilters({
    matchingStatuses,
    lifecycleStatuses,
    sources,
    uploadDateFrom,
    uploadDateTo,
    downloadStatus,
    searchQuery,
  })
  const appSourceFilterHint = getInvoiceAppSourceFilterHint(sources)
  const isNeedsAttentionFilter = isInvoiceMatchingWorkPreset(matchingStatuses)
  const matchingSummarySegments = useMemo(() => {
    const matchingCounts = tableSummary?.matchingCounts || {}
    const matchingSegments = INVOICE_MATCHING_SUMMARY_BUCKETS.map(bucket => {
      const count = matchingCounts[bucket.status] || 0
      if (!count) return null
      return {
        kind: 'matching',
        status: bucket.status,
        count,
        tone: bucket.tone,
        label: `${count} ${bucket.phrase}`,
      }
    }).filter(Boolean)

    const reconciledCount = tableSummary?.reconciledCount || 0
    const lifecycleSegments = reconciledCount
      ? [
          {
            kind: 'lifecycle',
            status: 'reconciled',
            count: reconciledCount,
            tone: 'success',
            label: `${reconciledCount} reconciled`,
          },
        ]
      : []

    return [...matchingSegments, ...lifecycleSegments]
  }, [tableSummary])
  const matchingWorkCount = tableSummary?.matchingWorkCount || 0
  const findWorkGuidance = useMemo(
    () =>
      getMatchQueueFindWorkGuidance({
        isNeedsAttentionFilter,
        visibleRowCount: tableData.length,
      }),
    [isNeedsAttentionFilter, tableData.length],
  )
  const nextMatchInvoice = useMemo(
    () => (findWorkGuidance ? pickNextMatchInvoice(tableData) : null),
    [findWorkGuidance, tableData],
  )
  const showNoOrderQueueTip = shouldShowNoOrderQueueTip({
    matchingStatuses,
    isNeedsAttentionFilter,
  })
  const noOrderLinks = getNoOrderGuidanceLinks(venueId)
  const selectedTypeFilterCount = matchingStatuses.length
  const tableEmptyText = getInvoicesTableEmptyText({
    isArchiveView,
    isNeedsAttentionFilter,
    hasActiveFilters,
  })
  const showInvoiceGuidedEmpty = shouldShowInvoiceUploadsGuidedEmpty({
    hasInvoices,
    guidedSuccess,
    loading: showFullScreenLoading,
    isArchiveView,
    isNeedsAttentionFilter,
    hasActiveFilters,
  })
  const beginFirstInvoice = item => {
    const pick = pickAcceptedSuggestedItem(item)
    setViewMode('active')
    setUploadPrefill({
      upload: true,
      po: pick?.purchaseOrderNumber || '',
      supplierId: pick?.supplierId || '',
      supplierTitle: pick?.title || '',
    })
    setRequestOpenUpload(count => count + 1)
  }
  const suggestedEmpty = bindGuidedEmptySuggestedActions({
    venueId,
    featureId: 'invoice_uploads',
    suggested,
    onStart: beginFirstInvoice,
  })
  const archivableFilteredInvoices = useMemo(
    () => getBulkArchivableInvoices(tableData),
    [tableData],
  )
  const deletableFilteredInvoices = useMemo(
    () => getBulkDeletableInvoices(tableData),
    [tableData],
  )
  const selectableFilteredInvoices = isArchiveView
    ? deletableFilteredInvoices
    : archivableFilteredInvoices
  const bulkSelectedCount = bulkSelectAllFiltered
    ? selectableFilteredInvoices.length
    : bulkSelectedRowKeys.length
  const showSelectAllFilteredPrompt = shouldShowSelectAllFilteredPrompt({
    bulkSelectAllFiltered,
    selectedRowKeys: bulkSelectedRowKeys,
    selectableFilteredCount: selectableFilteredInvoices.length,
  })
  const invoiceRowSelection = {
    selectedRowKeys: bulkSelectAllFiltered
      ? selectableFilteredInvoices.map(invoice => invoice.id)
      : bulkSelectedRowKeys,
    onChange: keys => {
      setBulkSelectAllFiltered(false)
      setBulkSelectedRowKeys(keys)
    },
    getCheckboxProps: record => ({
      disabled: isArchiveView ? false : !canArchiveInvoice(record),
    }),
  }

  const clearBulkSelection = () => {
    setBulkSelectedRowKeys([])
    setBulkSelectAllFiltered(false)
  }

  const handleBulkArchiveSelected = () => {
    const invoiceIds = getBulkArchiveInvoiceIds(tableData, {
      mode: bulkSelectAllFiltered
        ? BULK_SELECTION_MODE.ALL_FILTERED
        : BULK_SELECTION_MODE.PAGE,
      pageSelectedKeys: bulkSelectedRowKeys,
    })

    if (!invoiceIds.length) {
      RejectedNotification({
        message: 'No invoices selected',
        description: 'Select one or more invoices that can be archived.',
      })
      return
    }

    const countLabel = `${invoiceIds.length} invoice${
      invoiceIds.length === 1 ? '' : 's'
    }`

    Modal.confirm({
      title: `Archive ${countLabel}?`,
      content:
        'These invoices will be moved to your archived invoices. They will no longer appear in your active invoice list.',
      okText: `Archive ${countLabel}`,
      cancelText: 'Cancel',
      onOk: async () => {
        setBulkActionLoading(true)
        try {
          const result = await dispatch(
            bulkArchiveInvoices(venueId, invoiceIds, archivedByUsername),
          )
          const failures = buildBulkArchiveFailureRows(
            result?.results,
            tableData,
          )
          if (failures.length) {
            setBulkFailureModal({
              title: 'Some invoices could not be archived',
              description:
                'The invoices below were not archived. All other selected invoices were archived successfully.',
              rows: failures,
            })
          }
          clearBulkSelection()
        } catch (error) {
          // Notification handled in thunk.
        } finally {
          setBulkActionLoading(false)
        }
      },
    })
  }

  const handleBulkDeleteSelected = () => {
    const invoiceIds = getBulkDeleteInvoiceIds(tableData, {
      mode: bulkSelectAllFiltered
        ? BULK_SELECTION_MODE.ALL_FILTERED
        : BULK_SELECTION_MODE.PAGE,
      pageSelectedKeys: bulkSelectedRowKeys,
    })

    if (!invoiceIds.length) {
      RejectedNotification({
        message: 'No invoices selected',
        description: 'Select one or more archived invoices to delete.',
      })
      return
    }

    const countLabel = `${invoiceIds.length} invoice${
      invoiceIds.length === 1 ? '' : 's'
    }`

    Modal.confirm({
      title: `Delete ${countLabel}?`,
      content:
        'These invoices will be permanently deleted and cannot be restored. Are you sure?',
      okText: `Delete ${countLabel}`,
      okType: 'danger',
      cancelText: 'Cancel',
      onOk: async () => {
        setBulkActionLoading(true)
        try {
          const result = await dispatch(bulkDeleteInvoices(venueId, invoiceIds))
          const failures = buildBulkDeleteFailureRows(
            result?.results,
            tableData,
          )
          if (failures.length) {
            setBulkFailureModal({
              title: 'Some invoices could not be deleted',
              description:
                'The invoices below were not deleted. All other selected invoices were permanently deleted.',
              rows: failures,
            })
          }
          clearBulkSelection()
        } catch (error) {
          // Notification handled in thunk.
        } finally {
          setBulkActionLoading(false)
        }
      },
    })
  }

  const clearTableFilters = () => {
    setMatchingStatuses([])
    setLifecycleStatuses([])
    setSources([])
    setUploadDateRange([])
    setDownloadStatus('all')
    setSearchQuery('')
    if (location.search) {
      history.replace({
        pathname: location.pathname,
        search: '',
        hash: location.hash || '',
      })
    }
  }

  const handleToggleMatchingStatus = status => {
    setMatchingStatuses(prev => toggleMatchingStatusFilter(prev, status))
    setTypeFiltersOpen(true)
  }

  const handleNeedsAttentionFilter = () => {
    setMatchingStatuses(
      isNeedsAttentionFilter ? [] : [...INVOICE_MATCHING_WORK_STATUSES],
    )
  }

  const handleSummarySegmentClick = segment => {
    const status = typeof segment === 'string' ? segment : segment?.status
    const kind =
      typeof segment === 'string' ? 'matching' : segment?.kind || 'matching'

    if (kind === 'lifecycle') {
      if (
        lifecycleStatuses.length === 1 &&
        lifecycleStatuses[0] === status &&
        matchingStatuses.length === 0
      ) {
        setLifecycleStatuses([])
        return
      }
      setMatchingStatuses([])
      setLifecycleStatuses([status])
      return
    }

    if (matchingStatuses.length === 1 && matchingStatuses[0] === status) {
      setMatchingStatuses([])
      return
    }
    setLifecycleStatuses([])
    setMatchingStatuses([status])
    setTypeFiltersOpen(true)
  }

  return (
    <>
      <CreateOrderFromInvoiceModalStyle />
      {showFullScreenLoading ? (
        <Loading />
      ) : (
        <Content>
          {canConfigureRevenueCategories({ account, venue }) ? (
            <InvoiceForwardSettings
              venueId={venue._id}
              onCaughtUp={() =>
                loadActiveInvoicesPage({ page: tablePage, silent: true })
              }
            />
          ) : null}
          <ViewToggleRow>
            <Button
              type={!isArchiveView ? 'primary' : 'default'}
              onClick={() => setViewMode('active')}
            >
              Active Invoices
            </Button>
            <Button
              type={isArchiveView ? 'primary' : 'default'}
              onClick={() => setViewMode('archive')}
            >
              Archive
            </Button>
          </ViewToggleRow>
          {!isArchiveView && xeroBanner ? (
            <Alert
              key={xeroBanner.state}
              type={xeroBanner.tone}
              showIcon
              banner
              closable={xeroBanner.closable}
              style={{ marginBottom: 12, width: '100%' }}
              message={
                <XeroAutoSendBannerText>
                  <strong>{xeroBanner.title}</strong>
                  {xeroBanner.detail ? ` — ${xeroBanner.detail} ` : ' '}
                  <Link to={buildIntegrationsPath(venueId)}>
                    Manage in Integrations
                  </Link>
                  {!xeroBanner.showMapSuppliersCta &&
                  xeroBanner.showSuppliersLink ? (
                    <>
                      {' · '}
                      <Link to={buildVenueSuppliersPath(venueId)}>
                        Your Suppliers
                      </Link>
                    </>
                  ) : null}
                </XeroAutoSendBannerText>
              }
              action={
                xeroBanner.showMapSuppliersCta ? (
                  <Link to={buildVenueSuppliersPath(venueId)}>
                    <Button size='small' type='primary'>
                      {XERO_AUTO_SEND_MAP_SUPPLIERS_CTA}
                    </Button>
                  </Link>
                ) : null
              }
            />
          ) : null}
          {!isArchiveView && (
            <ThreeWayMatchEducation
              tab='invoices'
              venueId={venueId}
              defaultExpanded={!hasInvoices}
            >
              <InvoiceDetailGuide>
                <InvoiceDetailTitle>
                  Status &amp; matching on this tab
                </InvoiceDetailTitle>
                <InvoiceDetailGrid>
                  <div>
                    <InvoiceDetailSubtitle>
                      Status — invoice lifecycle
                    </InvoiceDetailSubtitle>
                    <StatusList>
                      {STATUS_EXPLANATIONS.map(item => (
                        <StatusItem key={item.label}>
                          <StatusIndicator color={item.color} />
                          <StatusText>
                            <StatusLabel>{item.label}</StatusLabel>
                            <StatusDescription>
                              {item.description}
                            </StatusDescription>
                          </StatusText>
                        </StatusItem>
                      ))}
                    </StatusList>
                  </div>
                  <div>
                    <InvoiceDetailSubtitle>
                      Matching — what our matcher found
                    </InvoiceDetailSubtitle>
                    <StatusList>
                      {MATCHING_EXPLANATIONS.map(item => (
                        <StatusItem key={item.label}>
                          <StatusIndicator color={item.color} />
                          <StatusText>
                            <StatusLabel>{item.label}</StatusLabel>
                            <StatusDescription>
                              {item.description}
                            </StatusDescription>
                          </StatusText>
                        </StatusItem>
                      ))}
                    </StatusList>
                  </div>
                </InvoiceDetailGrid>
                <StatusDescription>
                  <strong>Match &amp; reconcile</strong> attaches the invoice
                  and Full accepts the order on Goods receipting. Status mirrors
                  GR; Matching is only the engine recommendation.
                </StatusDescription>
              </InvoiceDetailGuide>
            </ThreeWayMatchEducation>
          )}
          {isArchiveView && (
            <p style={{ marginBottom: 16, color: '#595959', maxWidth: 720 }}>
              Archived invoices are kept for 30 days and can be restored at any
              time during this period. After 30 days they are permanently
              deleted.
            </p>
          )}
          {!isArchiveView && (
            <AllocateInvoiceToPosModal
              visible={allocateModalOpen}
              venueId={venueId}
              invoice={allocateInvoice}
              onCancel={closeAllocateModal}
              onAllocated={handleInvoiceAllocated}
            />
          )}
          {!isArchiveView && (
            <>
              {uploadPrefill?.upload ? (
                <Alert
                  type='info'
                  showIcon
                  closable
                  onClose={() => setUploadPrefill(null)}
                  style={{ marginBottom: 16 }}
                  message='Upload on Invoices'
                  description={
                    uploadPrefill.po || uploadPrefill.supplierTitle
                      ? `No invoice was ready to Match on Goods receipting. Use Add Invoices / Credit Notes below${
                          uploadPrefill.po ? ` for PO ${uploadPrefill.po}` : ''
                        }${
                          uploadPrefill.supplierTitle
                            ? ` (${uploadPrefill.supplierTitle})`
                            : ''
                        } — we’ll prefill what we can after you pick the file.`
                      : 'No invoice was ready to Match on Goods receipting. Use Add Invoices / Credit Notes below — the same upload flow as always.'
                  }
                />
              ) : null}
              {showXeroMetadataWarning ? (
                <Alert
                  type='warning'
                  showIcon
                  closable
                  style={{ marginBottom: 16 }}
                  message='Xero accounts could not be loaded'
                  description='You can still upload invoices and credit notes. Send to Xero may be limited until accounts load again.'
                />
              ) : null}
              <ControlStrip>
                <ControlStripPrimary>
                  <PrimaryActionLabel>Get started</PrimaryActionLabel>
                  <AddInvoices
                    venueId={venueId}
                    uploadPrefill={uploadPrefill}
                    requestOpenUpload={requestOpenUpload}
                    showIncompleteTray
                    onRefreshInvoices={async () => {
                      await loadActiveInvoicesPage({
                        page: tablePage,
                        silent: true,
                        includeSummary: true,
                      })
                    }}
                  />
                </ControlStripPrimary>
                <ControlStripSecondary>
                  <SecondaryControlsGrid>
                    <FilterSection>
                      <FilterLabel>Supplier (for download)</FilterLabel>
                      <TreeSelect
                        treeNodeFilterProp='title'
                        allowClear={true}
                        placeholder='Select a supplier'
                        showCheckedStrategy={TreeSelect.SHOW_CHILD}
                        dropdownStyle={{
                          background: 'white',
                        }}
                        style={{
                          width: '100%',
                        }}
                        value={selectedSupplier}
                        maxTagCount={1}
                        maxTagPlaceholder={omittedValues =>
                          `+ ${omittedValues.length} Supplier ...`
                        }
                        onChange={value => {
                          setSelectedSupplier(value)
                        }}
                        treeData={suppliers}
                      />
                      <DownloadButton
                        loading={downloading}
                        onClick={downloadAllInvoicesToFolder}
                        disabled={!selectedSupplier}
                      >
                        Download All
                      </DownloadButton>
                    </FilterSection>
                    <FilterSection>
                      <FilterLabel>Date range</FilterLabel>
                      <RangePicker
                        onFocus={() => setVisibleCalendar(true)}
                        onBlur={() => setVisibleCalendar(false)}
                        open={visibleCalendar}
                        disabledDate={disableEndDate}
                        onChange={onChangeDate}
                        style={{ width: '100%' }}
                      />
                      {rangeDate.length > 0 && (
                        <DownloadRangeButton
                          loading={downloadingRangeInvoices}
                          onClick={downloadRangeInvoicesToFolder}
                        >
                          Download Invoices
                        </DownloadRangeButton>
                      )}
                    </FilterSection>
                    <FilterSection>
                      <FilterLabel>Match tolerance</FilterLabel>
                      <ToleranceButton
                        type='primary'
                        onClick={() => setToleranceModalOpen(true)}
                        disabled={toleranceLoading && !toleranceSettings}
                      >
                        {toleranceLoading && !toleranceSettings
                          ? 'Loading match tolerance…'
                          : buildToleranceBadgeLabel(toleranceSettings || {})}
                      </ToleranceButton>
                    </FilterSection>
                  </SecondaryControlsGrid>
                </ControlStripSecondary>
              </ControlStrip>

              {/* 3-way match intro + expand guide live above controls via ThreeWayMatchEducation */}
            </>
          )}

          {!isArchiveView && (
            <InvoiceMatchToleranceModal
              visible={toleranceModalOpen}
              venueId={venueId}
              settings={toleranceSettings}
              loading={toleranceLoading}
              onCancel={() => setToleranceModalOpen(false)}
              onSaved={refreshed => {
                setToleranceSettings(refreshed)
                setToleranceModalOpen(false)
                if (venueId) {
                  void ensureInvoiceLibrary({ silent: true })
                  void loadActiveInvoicesPage({
                    page: tablePage,
                    silent: true,
                    includeSummary: true,
                  })
                }
              }}
            />
          )}
          <TableWrapper>
            <MatchingFiltersBar>
              <MatchingFiltersHeader>
                <div>
                  <MatchingFiltersTitle>Match queue</MatchingFiltersTitle>
                  <MatchingFiltersSubtitle>
                    Filter by matching status, lifecycle status, source, upload
                    date, download status, or free-text search
                  </MatchingFiltersSubtitle>
                </div>
                <MatchingResultCount>
                  Showing {tableData.length} of{' '}
                  {isArchiveView ? sourceTableData.length : serverTotal}
                </MatchingResultCount>
              </MatchingFiltersHeader>

              {matchingSummarySegments.length > 0 && (
                <MatchSummaryRow>
                  {matchingSummarySegments.map(segment => (
                    <MatchSummaryChip
                      key={`${segment.kind || 'matching'}-${segment.status}`}
                      type='button'
                      $tone={segment.tone}
                      $active={
                        segment.kind === 'lifecycle'
                          ? lifecycleStatuses.length === 1 &&
                            lifecycleStatuses[0] === segment.status &&
                            matchingStatuses.length === 0
                          : matchingStatuses.length === 1 &&
                            matchingStatuses[0] === segment.status
                      }
                      onClick={() => handleSummarySegmentClick(segment)}
                    >
                      {segment.label}
                    </MatchSummaryChip>
                  ))}
                </MatchSummaryRow>
              )}

              <MatchingPrimaryRow>
                <MatchingPresetButton
                  type='button'
                  $active={isNeedsAttentionFilter}
                  onClick={handleNeedsAttentionFilter}
                >
                  Needs my review
                  {matchingWorkCount > 0 ? ` (${matchingWorkCount})` : ''}
                </MatchingPresetButton>
                {shouldShowCreditRequestHealthBadge(openCreditRequestCount) ? (
                  <CreditRequestChip
                    to={buildCreditRequestsPath(venueId)}
                    title={`${openCreditRequestCount} open credit request${
                      openCreditRequestCount === 1 ? '' : 's'
                    }`}
                  >
                    Credit requests
                    <CreditRequestChipBadge>
                      {openCreditRequestCount}
                    </CreditRequestChipBadge>
                  </CreditRequestChip>
                ) : null}
                {hasActiveFilters && (
                  <ShowAllButton type='button' onClick={clearTableFilters}>
                    Show all
                  </ShowAllButton>
                )}
              </MatchingPrimaryRow>

              <Search
                allowClear
                placeholder='Search invoice #, PO, supplier, filename…'
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
                onSearch={value => setSearchQuery(value)}
                style={{ maxWidth: 360 }}
              />

              <TableFiltersRow>
                <TableFilterField>
                  <TableFilterLabel>Status</TableFilterLabel>
                  <Select
                    mode='multiple'
                    allowClear
                    placeholder='All statuses'
                    value={lifecycleStatuses}
                    onChange={setLifecycleStatuses}
                    style={{ width: '100%', minWidth: 180 }}
                    maxTagCount={1}
                    maxTagPlaceholder={omitted => `+${omitted.length}`}
                  >
                    {LIFECYCLE_STATUS_FILTER_OPTIONS.map(option => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                </TableFilterField>
                <TableFilterField>
                  <TableFilterLabel>Source</TableFilterLabel>
                  <Select
                    mode='multiple'
                    allowClear
                    placeholder='All sources'
                    value={sources}
                    onChange={setSources}
                    style={{ width: '100%', minWidth: 160 }}
                    maxTagCount={1}
                    maxTagPlaceholder={omitted => `+${omitted.length}`}
                  >
                    {SOURCE_FILTER_OPTIONS.map(option => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                  {appSourceFilterHint ? (
                    <SourceFilterHint>{appSourceFilterHint}</SourceFilterHint>
                  ) : null}
                </TableFilterField>
                <TableFilterField>
                  <TableFilterLabel>Upload date</TableFilterLabel>
                  <RangePicker
                    allowClear
                    value={uploadDateRange}
                    onChange={dates => setUploadDateRange(dates || [])}
                    format='DD/MM/YYYY'
                    style={{ width: '100%', minWidth: 220 }}
                    placeholder={['From', 'To']}
                  />
                </TableFilterField>
                <TableFilterField>
                  <TableFilterLabel>Download status</TableFilterLabel>
                  <Select
                    value={downloadStatus}
                    onChange={value => setDownloadStatus(value || 'all')}
                    style={{ width: '100%', minWidth: 160 }}
                  >
                    {DOWNLOAD_STATUS_FILTER_OPTIONS.map(option => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                </TableFilterField>
              </TableFiltersRow>

              <TypeFiltersCollapse
                activeKey={typeFiltersOpen ? ['types'] : []}
                onChange={keys =>
                  setTypeFiltersOpen(
                    Array.isArray(keys)
                      ? keys.includes('types')
                      : keys === 'types',
                  )
                }
                bordered={false}
              >
                <CollapsePanel
                  key='types'
                  header={
                    <TypeFiltersHeader>
                      Filter by match type
                      {selectedTypeFilterCount > 0 &&
                        !isNeedsAttentionFilter && (
                          <TypeFiltersBadge>
                            {selectedTypeFilterCount} selected
                          </TypeFiltersBadge>
                        )}
                    </TypeFiltersHeader>
                  }
                >
                  <MatchingChipsRow>
                    {MATCHING_FILTER_OPTIONS.map(option => (
                      <MatchingChip
                        key={option.value}
                        type='button'
                        $tone={option.tone}
                        $active={matchingStatuses.includes(option.value)}
                        onClick={() => handleToggleMatchingStatus(option.value)}
                      >
                        {option.label}
                      </MatchingChip>
                    ))}
                  </MatchingChipsRow>
                </CollapsePanel>
              </TypeFiltersCollapse>
            </MatchingFiltersBar>
            {showNoOrderQueueTip ? (
              <NoOrderQueueTip role='note'>
                {NO_ORDER_QUEUE_TIP}{' '}
                {noOrderLinks.receipting ? (
                  <NoOrderQueueLink to={noOrderLinks.receipting}>
                    Goods receipting
                  </NoOrderQueueLink>
                ) : null}
                {noOrderLinks.ordersManual ? (
                  <>
                    {' · '}
                    <NoOrderQueueLink to={noOrderLinks.ordersManual}>
                      Add manual order
                    </NoOrderQueueLink>
                  </>
                ) : null}
              </NoOrderQueueTip>
            ) : null}
            {findWorkGuidance ? (
              <FindWorkBanner role='status'>
                <FindWorkSentence>{findWorkGuidance.sentence}</FindWorkSentence>
                {nextMatchInvoice ? (
                  <Button
                    type='primary'
                    onClick={() => handleMatchInvoice(nextMatchInvoice)}
                  >
                    {findWorkGuidance.ctaLabel}
                  </Button>
                ) : null}
              </FindWorkBanner>
            ) : null}
            {!isArchiveView && bulkSelectedCount > 0 ? (
              <BulkSelectionBanner role='status'>
                <BulkSelectionText>
                  <strong>
                    {bulkSelectedCount} invoice
                    {bulkSelectedCount === 1 ? '' : 's'} selected
                  </strong>
                  {showSelectAllFilteredPrompt ? (
                    <>
                      {' '}
                      <BulkSelectionLink
                        type='button'
                        onClick={() => setBulkSelectAllFiltered(true)}
                      >
                        Select all {selectableFilteredInvoices.length} invoices
                        matching these filters
                      </BulkSelectionLink>
                    </>
                  ) : null}
                </BulkSelectionText>
                <BulkSelectionActions>
                  <ShowAllButton type='button' onClick={clearBulkSelection}>
                    Clear selection
                  </ShowAllButton>
                  <Button
                    type='primary'
                    loading={bulkActionLoading}
                    onClick={handleBulkArchiveSelected}
                  >
                    Archive Selected
                  </Button>
                </BulkSelectionActions>
              </BulkSelectionBanner>
            ) : null}
            {isArchiveView && bulkSelectedCount > 0 ? (
              <BulkSelectionBanner $tone='danger' role='status'>
                <BulkSelectionText>
                  <strong>
                    {bulkSelectedCount} invoice
                    {bulkSelectedCount === 1 ? '' : 's'} selected
                  </strong>
                  {showSelectAllFilteredPrompt ? (
                    <>
                      {' '}
                      <BulkSelectionLink
                        type='button'
                        onClick={() => setBulkSelectAllFiltered(true)}
                      >
                        Select all {selectableFilteredInvoices.length} invoices
                        matching these filters
                      </BulkSelectionLink>
                    </>
                  ) : null}
                </BulkSelectionText>
                <BulkSelectionActions>
                  <ShowAllButton type='button' onClick={clearBulkSelection}>
                    Clear selection
                  </ShowAllButton>
                  <Button
                    type='danger'
                    loading={bulkActionLoading}
                    onClick={handleBulkDeleteSelected}
                  >
                    Delete Selected
                  </Button>
                </BulkSelectionActions>
              </BulkSelectionBanner>
            ) : null}
            <StyledTable
              loading={!isArchiveView && tableBusy}
              dataSource={tableData.map(invoice => ({
                key: invoice.id,
                ...invoice,
              }))}
              rowSelection={invoiceRowSelection}
              columns={InvoicesColumns(
                venueId,
                handleDownloadInvoice,
                downloadingInvoice,
                invoice => {
                  setReopenMatchAfterEdit(false)
                  setEditInvoice(invoice)
                },
                loadingRowId,
                setLoadingRowId,
                dispatch,
                viewMode,
                archivedByUsername,
                handleMatchInvoice,
                handleAllocateInvoice,
                setDuplicateModalInvoice,
                setAuditDrawerInvoice,
                handleRematchInvoice,
                rematchingInvoiceId,
                handleDismissDuplicate,
                dismissingDuplicateInvoiceId,
                handleUnreconcileInvoice,
                () => loadActiveInvoicesPage({ page: tablePage, silent: true }),
                handleCreateMatchingManualOrder,
                creatingMatchingManualOrderInvoiceId,
                forwardAddresses,
                emailInvoiceRow,
                setGoodsReceiptEditInvoice,
              )}
              scroll={RESPONSIVE_TABLE_SCROLL}
              locale={{
                emptyText: showInvoiceGuidedEmpty ? (
                  <GrowthEngineFeatureEmptyState
                    featureId='invoice_uploads'
                    title={guidedSuccess.emptyState.title}
                    body={guidedSuccess.emptyState.body}
                    valueLine={guidedSuccess.emptyState.valueLine}
                    estimatedMinutes={guidedSuccess.emptyState.estimatedMinutes}
                    ctaLabel={guidedSuccess.emptyState.cta?.label}
                    suggestedLabel='Start with a PO that still needs an invoice'
                    onCta={suggestedEmpty.onCta}
                    suggestedItems={suggestedEmpty.suggestedItems}
                    onSuggestedItem={suggestedEmpty.onSuggestedItem}
                    onSuggestedEdit={suggestedEmpty.onSuggestedEdit}
                    onRejectSuggested={suggestedEmpty.onRejectSuggested}
                  />
                ) : (
                  tableEmptyText
                ),
              }}
              pagination={
                isArchiveView
                  ? {
                      pageSize: INVOICES_INFO_PAGE_SIZE,
                      showSizeChanger: false,
                      position: 'both',
                      hideOnSinglePage: true,
                    }
                  : {
                      current: tablePage,
                      pageSize: INVOICES_INFO_PAGE_SIZE,
                      total: serverTotal,
                      showSizeChanger: false,
                      position: 'both',
                      hideOnSinglePage: true,
                      onChange: page => setTablePage(page),
                    }
              }
            />
          </TableWrapper>
          <DuplicateResolutionModal
            open={Boolean(duplicateModalInvoice)}
            invoice={duplicateModalInvoice}
            invoices={
              uploadedInvoices?.length
                ? uploadedInvoices.map(invoice => mapInvoiceToTableRow(invoice))
                : dataSourse
            }
            venueId={venueId}
            onClose={() => setDuplicateModalInvoice(null)}
            onDismissDuplicate={handleDismissDuplicate}
            onMergePages={handleMergePages}
            dismissing={Boolean(dismissingDuplicateInvoiceId)}
            merging={Boolean(mergingPagesInvoiceId)}
          />
          <UnreconcileInvoiceModal
            open={Boolean(unreconcileModalInvoice)}
            invoice={unreconcileModalInvoice}
            venueId={venueId}
            onClose={() => setUnreconcileModalInvoice(null)}
            onSuccess={handleUnreconcileCompleted}
          />
          <InvoiceAuditHistoryDrawer
            open={Boolean(auditDrawerInvoice)}
            invoice={auditDrawerInvoice}
            onClose={() => setAuditDrawerInvoice(null)}
          />
          <Drawer
            title='Edit goods receipt'
            visible={Boolean(goodsReceiptEditInvoice)}
            width={1040}
            destroyOnClose
            onClose={() => {
              setGoodsReceiptEditInvoice(null)
              loadActiveInvoicesPage({ page: tablePage, silent: true })
            }}
          >
            {goodsReceiptEditInvoice ? (
              <Receipting
                embedded
                embeddedPo={String(
                  goodsReceiptEditInvoice.purchaseOrderNumber ||
                    goodsReceiptEditInvoice.poAllocations?.[0]
                      ?.purchaseOrderNumber ||
                    '',
                ).trim()}
                onReceiptSaved={() => {
                  setGoodsReceiptEditInvoice(null)
                  loadActiveInvoicesPage({ page: tablePage, silent: true })
                }}
              />
            ) : null}
          </Drawer>
          <CreditNoteCoachModal
            visible={creditNoteCoachOpen && !isArchiveView}
            onGotIt={() => {
              dismissCreditNoteCoach(venueId)
              setCreditNoteCoachOpen(false)
            }}
            onNotNow={() => setCreditNoteCoachOpen(false)}
          />
          <Modal
            visible={Boolean(bulkFailureModal?.rows?.length)}
            title={
              bulkFailureModal?.title || 'Some invoices could not be updated'
            }
            footer={[
              <Button
                key='close'
                type='primary'
                onClick={() => setBulkFailureModal(null)}
              >
                Close
              </Button>,
            ]}
            onCancel={() => setBulkFailureModal(null)}
            width={720}
          >
            <p style={{ marginBottom: 12, color: '#595959' }}>
              {bulkFailureModal?.description}
            </p>
            <Table
              size='small'
              pagination={false}
              dataSource={bulkFailureModal?.rows || []}
              columns={[
                {
                  title: 'Supplier',
                  dataIndex: 'supplierTitle',
                  key: 'supplierTitle',
                },
                {
                  title: 'Invoice',
                  dataIndex: 'invoiceNumber',
                  key: 'invoiceNumber',
                },
                {
                  title: 'Reason',
                  dataIndex: 'message',
                  key: 'message',
                },
              ]}
            />
          </Modal>
        </Content>
      )}
      {!isArchiveView && (
        <MatchInvoiceModal
          visible={Boolean(matchModalInvoice)}
          venueId={venueId}
          invoice={matchModalInvoice}
          username={archivedByUsername}
          uploadedInvoices={
            uploadedInvoices?.length
              ? uploadedInvoices.map(invoice => mapInvoiceToTableRow(invoice))
              : dataSourse
          }
          onCancel={closeMatchModal}
          onLinked={handleInvoiceMatched}
          onReconciled={handleInvoiceMatched}
          onRemoved={handleInvoiceMatched}
          onFixDetails={handleFixDetailsFromMatch}
        />
      )}
      <Modal
        width={960}
        title='Create order from invoice'
        okText='Confirm & link invoice'
        cancelText='Cancel'
        visible={manualOrderModalOpen}
        confirmLoading={manualOrderSaving}
        className='create-order-from-invoice-modal'
        okButtonProps={{
          disabled: manualOrderInvalid,
          style: { background: '#7cb305', borderColor: '#7cb305' },
        }}
        onOk={handleSaveMatchingManualOrder}
        onCancel={closeManualOrderModal}
        destroyOnClose
      >
        <CreateOrderFromInvoiceIntro>
          Review the proposed historical order built from this invoice. Correct
          anything needed, then confirm. OMS will create the order, assign a PO,
          and <strong>link this invoice automatically</strong> — then open Match
          so you can reconcile. Nothing is sent to the supplier.
        </CreateOrderFromInvoiceIntro>
        <AddInvoiceModal
          showModal={manualOrderModalOpen}
          order={manualOrderDraft}
          setOrder={setManualOrderDraft}
          suppliers={allVenueSuppliersForManualOrder}
          initialPoNumber={
            manualOrderProposalBundle?.proposal?.poNumber ||
            manualOrderForInvoice?.purchaseOrderNumber ||
            ''
          }
          proposalToApply={manualOrderProposalBundle}
          showAiBuildPanel={false}
          onWholeOrderDiscountChange={setManualOrderDiscountPounds}
        />
      </Modal>
      <Modal
        title={
          reopenMatchAfterEdit ? 'Fix invoice details' : 'Edit invoice details'
        }
        visible={editInvoice !== null}
        width={520}
        onOk={async () => {
          if (!canEditInvoiceDetails(editInvoice)) {
            RejectedNotification({
              message: 'Invoice locked',
              description:
                getEditInvoiceDetailsBlockReason(editInvoice) ||
                'This invoice cannot be edited.',
            })
            closeEditInvoiceModal()
            return
          }

          const originalPo = String(
            editInvoice?.purchaseOrderNumber || '',
          ).trim()
          const nextPo = String(
            updatedInvoice?.purchaseOrderNumber || '',
          ).trim()
          const poChanged = originalPo !== nextPo
          const originalType = editInvoice?.documentType || 'invoice'
          const nextType = updatedInvoice?.documentType || 'invoice'
          const flippingToCreditNote =
            originalType !== 'creditNote' && nextType === 'creditNote'
          const payload = buildEditInvoiceSavePayload(updatedInvoice)

          const save = async () => {
            const result = await dispatch(
              editInvoiceInDatabase(venueId, editInvoice.id, payload),
            )
            if (!result) {
              return Promise.reject(new Error('Invoice update failed'))
            }

            const shouldReopenMatch = reopenMatchAfterEdit
            setEditInvoice(null)
            setReopenMatchAfterEdit(false)

            await loadActiveInvoicesPage({
              page: tablePage,
              silent: true,
              includeSummary: true,
            })

            if (shouldReopenMatch) {
              const updatedRow = result.invoice
                ? mapInvoiceToTableRow(result.invoice)
                : editInvoice
              void ensureInvoiceLibrary({ silent: true })
              setMatchModalInvoice(updatedRow)
            }

            return result
          }

          if (flippingToCreditNote || poChanged) {
            const parts = []
            if (flippingToCreditNote) {
              parts.push(
                'Credit notes use a negative total and are matched manually — they will not one-click reconcile like a standard invoice.',
              )
            }
            if (poChanged) {
              parts.push(
                originalPo
                  ? `Update PO from “${originalPo}” to “${
                      nextPo || '(empty)'
                    }”? This only edits the invoice field — it does not attach or unlink on Goods Receipting.`
                  : `Set PO to “${
                      nextPo || '(empty)'
                    }”? This only edits the invoice field — attach from Match or Goods Receipting to link the file to an order.`,
              )
            }
            return new Promise((resolve, reject) => {
              Modal.confirm({
                title: flippingToCreditNote
                  ? 'Save credit note changes?'
                  : 'Change purchase order number?',
                content: parts.join(' '),
                okText: flippingToCreditNote
                  ? 'Save as credit note'
                  : 'Change PO',
                cancelText: 'Cancel',
                onOk: () => save().then(resolve).catch(reject),
                onCancel: () => reject(),
              })
            })
          }

          return save()
        }}
        confirmLoading={updatingLoading}
        onCancel={() => {
          closeEditInvoiceModal({ reopenMatch: true })
        }}
      >
        {editInvoice ? (
          <EditInvoiceForm>
            <label>Supplier</label>
            <Select
              showSearch
              allowClear
              placeholder='Select venue supplier'
              optionFilterProp='children'
              value={updatedInvoice.supplier || undefined}
              onChange={value => {
                setUpdatedInvoice(prevState =>
                  applyEditInvoiceSupplierSelect(
                    prevState,
                    value,
                    venueSuppliers,
                  ),
                )
              }}
            >
              {updatedInvoice.supplier &&
              !(venueSuppliers || []).some(
                row => String(row._id) === String(updatedInvoice.supplier),
              ) ? (
                <Option
                  key={String(updatedInvoice.supplier)}
                  value={String(updatedInvoice.supplier)}
                >
                  {updatedInvoice.supplierTitle ||
                    String(updatedInvoice.supplier)}
                </Option>
              ) : null}
              {(venueSuppliers || []).map(row => (
                <Option key={String(row._id)} value={String(row._id)}>
                  {row.supplierTitle || String(row._id)}
                </Option>
              ))}
            </Select>
            {!updatedInvoice.supplier ? (
              <>
                <label>
                  Supplier name (if not in OMS)
                  {isEditInvoiceNonOmsSupplier(updatedInvoice) ? (
                    <NonOmsBadge>{NON_OMS_SUPPLIER_BADGE_LABEL}</NonOmsBadge>
                  ) : null}
                </label>
                <Input
                  placeholder='Type supplier name'
                  value={updatedInvoice.supplierTitle || ''}
                  onChange={e =>
                    setUpdatedInvoice(prevState =>
                      applyEditInvoiceSupplierTitleInput(
                        prevState,
                        e.target.value,
                      ),
                    )
                  }
                />
                {isEditInvoiceNonOmsSupplier(updatedInvoice) ? (
                  <EditInvoiceHint>
                    This supplier isn’t on OMS yet. You can still save —{' '}
                    <Link to={getVenueSuppliersPath(venueId)} target='_blank'>
                      add them under Your Suppliers
                    </Link>{' '}
                    so future invoices match automatically. Clear the name to
                    remove the supplier.
                  </EditInvoiceHint>
                ) : (
                  <EditInvoiceHint>
                    Leave blank to clear the supplier, or type a name if they
                    are not on OMS yet.
                  </EditInvoiceHint>
                )}
              </>
            ) : null}

            <label>Invoice number</label>
            <Input
              value={updatedInvoice.invoiceNumber || ''}
              onChange={e =>
                setUpdatedInvoice(prevState => ({
                  ...prevState,
                  invoiceNumber: e.target.value,
                }))
              }
            />

            <label>Invoice date</label>
            <DatePicker
              style={{ width: '100%' }}
              format='YYYY-MM-DD'
              value={
                updatedInvoice.invoiceDate
                  ? moment(updatedInvoice.invoiceDate, 'YYYY-MM-DD')
                  : null
              }
              onChange={date =>
                setUpdatedInvoice(prevState => ({
                  ...prevState,
                  invoiceDate: date ? date.format('YYYY-MM-DD') : '',
                }))
              }
            />

            <label>Total (including VAT)</label>
            <Input
              placeholder={
                updatedInvoice.documentType === 'creditNote'
                  ? 'e.g. -12.00'
                  : 'e.g. 51.95'
              }
              value={updatedInvoice.invoiceTotalInput || ''}
              onChange={e =>
                setUpdatedInvoice(prevState => ({
                  ...prevState,
                  invoiceTotalInput: e.target.value,
                }))
              }
            />
            <EditInvoiceHint>
              {updatedInvoice.documentType === 'creditNote'
                ? 'Credit notes use a negative total (sign flips automatically when you change document type).'
                : INVOICE_TOTAL_HELPER_TEXT}
            </EditInvoiceHint>

            <label>Document type</label>
            <Select
              value={updatedInvoice.documentType || 'invoice'}
              onChange={value =>
                setUpdatedInvoice(prevState =>
                  applyDocumentTypeFlipToEditState(prevState, value),
                )
              }
            >
              <Option value='invoice'>Invoice</Option>
              <Option value='creditNote'>Credit Note</Option>
            </Select>
            {updatedInvoice.documentType === 'creditNote' ? (
              <EditInvoiceHint>
                {CN_DOCUMENT_COPY.matchingGuidance}
              </EditInvoiceHint>
            ) : null}

            <label>PO number</label>
            <Input
              value={updatedInvoice.purchaseOrderNumber || ''}
              onChange={e =>
                setUpdatedInvoice(prevState => ({
                  ...prevState,
                  purchaseOrderNumber: e.target.value,
                }))
              }
            />
            <EditInvoiceHint>
              Changing PO here only updates the invoice field. Use Match or Link
              to attach on Goods Receipting.
            </EditInvoiceHint>

            <label>Notes</label>
            <Input.TextArea
              rows={3}
              value={updatedInvoice.comment || ''}
              onChange={e =>
                setUpdatedInvoice(prevState => ({
                  ...prevState,
                  comment: e.target.value,
                }))
              }
            />
          </EditInvoiceForm>
        ) : null}
      </Modal>
    </>
  )
}

const CreateOrderFromInvoiceIntro = styled.p`
  margin: 0 0 14px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 13px;
  line-height: 1.45;
`

const CreateOrderFromInvoiceModalStyle = createGlobalStyle`
  .create-order-from-invoice-modal .ant-modal-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    padding: 12px 24px 16px;
    border-top: 1px solid #f0f0f0;
  }
  .create-order-from-invoice-modal .ant-modal-footer button {
    margin: 0 !important;
    min-width: 96px;
  }
  .create-order-from-invoice-modal .ant-modal-footer::before,
  .create-order-from-invoice-modal .ant-modal-footer::after {
    display: none;
  }
  .create-order-from-invoice-modal .ant-modal-body {
    padding-top: 12px;
    padding-bottom: 8px;
  }
`

const EditInvoiceForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  label {
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;
  }
`

const NonOmsBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  color: #ad6800;
  background: #fff7e6;
  border: 1px solid #ffd591;
`

const EditInvoiceHint = styled.div`
  margin-top: -4px;
  margin-bottom: 4px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  line-height: 1.4;
`

const TableWrapper = styled.div`
  width: 100%;
  min-width: 0;
  max-width: 100%;
  text-align: center;
  position: relative;
  ${visibleHorizontalScroll}
  ${antdTableHorizontalScroll}
`

const StyledTable = styled(Table)`
  .ant-table-thead {
    white-space: nowrap;
  }
  .ant-table-thead > tr > th {
    white-space: normal;
    word-break: keep-all;
    overflow-wrap: break-word;
    line-height: 1.25;
  }
  .ant-table-tbody > tr > td {
    word-break: keep-all;
    overflow-wrap: normal;
  }
  .ant-table-tbody > tr > td.matching-column {
    vertical-align: top;
  }
  .ant-pagination-prev .ant-pagination-item-link,
  .ant-pagination-next .ant-pagination-item-link {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    border-right: 1px solid #e8e8e8;
  }

  ${antdTableHorizontalScroll}
`

const MatchingFiltersBar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
  padding: 16px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  text-align: left;
`

const NoOrderQueueTip = styled.div`
  margin: -4px 0 14px;
  padding: 10px 12px;
  font-size: 13px;
  line-height: 1.45;
  color: #874d00;
  background: #fffbe6;
  border: 1px solid #ffe58f;
  border-radius: 8px;
  text-align: left;
`

const NoOrderQueueLink = styled(Link)`
  font-weight: 600;
  color: #d46b08;
  text-decoration: underline;

  &:hover {
    color: #ad4e00;
  }
`

const MatchingFiltersHeader = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`

const MatchingFiltersTitle = styled.div`
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
`

const MatchingFiltersSubtitle = styled.div`
  margin-top: 2px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  font-weight: 400;
`

const MatchingResultCount = styled.div`
  font-size: 13px;
  color: rgba(0, 0, 0, 0.45);
  white-space: nowrap;
  padding-top: 2px;
`

const TableFiltersRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
  width: 100%;
`

const TableFilterField = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1 1 180px;
  max-width: 280px;
`

const TableFilterLabel = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.65);
`

const SourceFilterHint = styled.div`
  font-size: 12px;
  line-height: 1.35;
  color: rgba(0, 0, 0, 0.55);
  max-width: 260px;
`

const MatchSummaryRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
`

const MatchSummaryChip = styled.button`
  border: 1px solid
    ${props =>
      props.$active
        ? getInvoiceMatchingStatusToneStyles(props.$tone).activeBorder
        : getInvoiceMatchingStatusToneStyles(props.$tone).border};
  background: ${props =>
    props.$active
      ? getInvoiceMatchingStatusToneStyles(props.$tone).activeBackground
      : '#ffffff'};
  color: ${props =>
    props.$active
      ? getInvoiceMatchingStatusToneStyles(props.$tone).color
      : '#434343'};
  border-radius: 999px;
  padding: 4px 12px;
  font-size: 13px;
  font-weight: ${props => (props.$active ? 600 : 400)};
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover {
    border-color: ${props =>
      getInvoiceMatchingStatusToneStyles(props.$tone).activeBorder};
  }
`

const MatchingPrimaryRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
`

const MatchingPresetButton = styled.button`
  border: 1px solid ${props => (props.$active ? '#fa8c16' : '#d9d9d9')};
  background: ${props => (props.$active ? '#fff7e6' : '#ffffff')};
  color: ${props => (props.$active ? '#873800' : '#434343')};
  border-radius: 999px;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover {
    border-color: #fa8c16;
  }
`

const ShowAllButton = styled.button`
  border: none;
  background: transparent;
  color: #8c8c8c;
  font-size: 13px;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;

  &:hover {
    color: #595959;
  }
`

const CreditRequestChip = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #ffd591;
  background: #fff7e6;
  color: #873800;
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  transition: border-color 0.15s ease, background 0.15s ease;

  &:hover {
    border-color: #fa8c16;
    color: #873800;
  }
`

const CreditRequestChipBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: ${RECEIPTING_HEALTH_BADGE_COLOR};
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
`

const FindWorkBanner = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  padding: 12px 14px;
  border-radius: 6px;
  background: #fff7e6;
  border: 1px solid #ffd591;
`

const BulkSelectionBanner = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  padding: 12px 14px;
  border-radius: 6px;
  background: ${props => (props.$tone === 'danger' ? '#fff1f0' : '#f0f5ff')};
  border: 1px solid
    ${props => (props.$tone === 'danger' ? '#ffa39e' : '#adc6ff')};
`

const BulkSelectionText = styled.div`
  flex: 1 1 240px;
  font-size: 14px;
  line-height: 1.45;
  color: rgba(0, 0, 0, 0.85);
`

const BulkSelectionLink = styled.button`
  border: none;
  background: transparent;
  color: #1d39c4;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  text-decoration: underline;

  &:hover {
    color: #10239e;
  }
`

const BulkSelectionActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
`

const FindWorkSentence = styled.p`
  margin: 0;
  flex: 1 1 240px;
  font-size: 14px;
  line-height: 1.45;
  color: #873800;
`

const MatchingChipsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

const MatchingChip = styled.button`
  border: 1px solid
    ${props =>
      props.$active
        ? getInvoiceMatchingStatusToneStyles(props.$tone).activeBorder
        : '#d9d9d9'};
  background: ${props =>
    props.$active
      ? getInvoiceMatchingStatusToneStyles(props.$tone).activeBackground
      : '#ffffff'};
  color: ${props =>
    props.$active
      ? getInvoiceMatchingStatusToneStyles(props.$tone).color
      : '#434343'};
  border-radius: 999px;
  padding: 4px 12px;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover {
    border-color: ${props =>
      getInvoiceMatchingStatusToneStyles(props.$tone).activeBorder};
  }
`

const TypeFiltersCollapse = styled(Collapse)`
  && {
    width: 100%;
    background: transparent;

    .ant-collapse-item {
      border: none;
    }

    .ant-collapse-header {
      /* Extra left padding so the expand arrow does not overlap the label */
      padding: 4px 0 4px 28px !important;
      align-items: center !important;
      color: rgba(0, 0, 0, 0.65);
      font-size: 13px;
    }

    .ant-collapse-arrow {
      left: 0 !important;
    }

    .ant-collapse-content-box {
      padding: 8px 0 0 !important;
    }
  }
`

const TypeFiltersHeader = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-left: 4px;
`

const TypeFiltersBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0 8px;
  height: 20px;
  border-radius: 10px;
  background: #f0f5ff;
  color: #1d39c4;
  font-size: 11px;
  font-weight: 600;
`

const Content = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`

const ViewToggleRow = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
`

const XeroAutoSendBannerText = styled.span`
  font-size: 13px;
  line-height: 1.4;
`

const ControlStrip = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
  padding: 20px 24px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
`

const ControlStripPrimary = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
`

const PrimaryActionLabel = styled.div`
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.45);
`

const ControlStripSecondary = styled.div`
  width: 100%;
`

const SecondaryControlsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px 20px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`

const FilterSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const FilterLabel = styled.label`
  font-size: 13px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.65);
  margin: 0;
`

const ToleranceButton = styled(Button)`
  && {
    width: auto;
    min-width: 0;
    height: 32px;
    padding: 0 16px;
    white-space: nowrap;
    line-height: 1.35;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    color: #ffffff;
    background: #b5d922;
    border: 1px solid #b5d922;
    border-radius: 4px;
    box-shadow: none;

    &:hover,
    &:focus {
      color: #ffffff;
      background: #a3c41e;
      border-color: #a3c41e;
    }

    &:disabled {
      color: rgba(0, 0, 0, 0.25);
      background: #f5f5f5;
      border-color: #d9d9d9;
    }
  }
`

const DownloadButton = styled(LoadingButton)`
  width: auto;
  height: 40px;
`

const DownloadRangeButton = styled(LoadingButton)`
  width: auto;
  height: 40px;
  margin-top: 0;
`

const InvoiceDetailGuide = styled.div`
  margin-top: 4px;
  padding-top: 14px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const InvoiceDetailTitle = styled.h4`
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
`

const InvoiceDetailSubtitle = styled.h5`
  margin: 0 0 8px;
  font-size: 12px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.65);
`

const InvoiceDetailGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 24px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`

const StatusList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const StatusItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
`

const StatusIndicator = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${props => props.color};
  flex-shrink: 0;
  margin-top: 4px;
`

const StatusText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
`

const StatusLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #333;
`

const StatusDescription = styled.span`
  font-size: 12px;
  color: #666;
  line-height: 1.45;
`

export default InvoicesScreen
